import { render, staticRenderFns } from "./TCLADashboard.vue?vue&type=template&id=4850541f&scoped=true"
import script from "./TCLADashboard.vue?vue&type=script&lang=js"
export * from "./TCLADashboard.vue?vue&type=script&lang=js"
import style0 from "./TCLADashboard.vue?vue&type=style&index=0&id=4850541f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850541f",
  null
  
)

export default component.exports